"use strict";
var SelectionItem = (function () {
    function SelectionItem(id, title, selected, disabled) {
        this.id = id;
        this.title = title;
        this.selected = selected;
        this.disabled = disabled;
    }
    return SelectionItem;
}());
exports.SelectionItem = SelectionItem;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/models/selection-item.js
// module id = 40
// module chunks = 0